import { useEffect, useState } from "react";
import { adminRequest } from "./api";
import { useAdminContext } from "./context";
import type { AdminEnvelope } from "./types";

export function useAdminData<T>(path: string | null): Readonly<{
  envelope: AdminEnvelope<T> | null;
  loading: boolean;
  error: string | null;
  reload: () => void;
}> {
  const { tokens, refreshNonce } = useAdminContext();
  const [nonce, setNonce] = useState(0);
  const [envelope, setEnvelope] = useState<AdminEnvelope<T> | null>(null);
  const [loading, setLoading] = useState(Boolean(path));
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    if (!path) { setEnvelope(null); setError(null); setLoading(false); return; }
    let alive = true;
    setLoading(true);
    setError(null);
    void adminRequest<T>(path, tokens).then((next) => { if (alive) setEnvelope(next); })
      .catch((reason: unknown) => { if (alive) setError(reason instanceof Error ? reason.message : "The request failed."); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [path, tokens, nonce, refreshNonce]);
  return { envelope, loading, error, reload: () => setNonce((value) => value + 1) };
}
